import Bugsnag from '@bugsnag/js'

function errorNotify(errorMessage, severity, context, metaData) {
    if (window.BUGSNAG_VUE_API_KEY) {
        Bugsnag.notify(new Error(errorMessage), function (event) {
            event.severity = severity
            event.context = context
            event.addMetadata('data', metaData)
        })
    }
}

export { errorNotify }
